export enum TimeFormat {
  fullTime = 'dd.MM.yyyy, HH:mm',
  fullTime2 = 'dd.MM.yyyy HH:mm',
  fullTimeHyphenated = 'dd-MMM-yy, HH:mm',
  date = 'dd.MM.yyyy',
  timeFirstDate = 'HH:mm, dd.MM.yyyy',
  timeDate = 'HH:mm dd.MM.yyyy'
}
